import React, { useState } from "react";
import "./../Assets/css/header.css";
// import logo from "./../Assets/images/logo.png";
import FRED from "./../Assets/images/FRED.png";
// import {ReactComponent as User} from './../Assets/images/svg/user.svg'
import UserAvatar from "./../Assets/images/User.png";
import { NavDropdown, Spinner } from "react-bootstrap";
import { Link, Navigate } from "react-router-dom";
import { useNavigate, useLocation } from "react-router-dom";

export const Header = ({ userName, move_floor }) => {
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const pathName = location.pathname;

  const handleLogout = () => {
    setIsLoading(true);
    localStorage.removeItem("user");
  };
  const user = JSON.parse(localStorage.getItem("user"));
  if (!user?.token) {
    return <Navigate to="/" />;
  }
  // console.log("pathname", location.pathname);
  return (
    <div className="header sticky-top wrapper">
      <div className="header_content stickyHeader ">
        <div className="header_left ">
          <img className="header_logo" src={FRED} alt="FRED" />

          {user?.user_role === "reception" && (
            <Link to="/reports" className="btn btn-primary">
              View Report
            </Link>
          )}
          {pathName === "/reports" ? (
            <button className="btn btn-primary" onClick={() => navigate(-1)}>
              Go Back
            </button>
          ) : (
            ""
          )}
        </div>

        <div className="header_right">
          <p>{userName}</p>
          <div className="Avatar">
            <img className="UserAvatar" src={UserAvatar} alt="user" />
            {/* <User /> */}
            <NavDropdown id="basic-nav-dropdown">
              <NavDropdown.Item onClick={handleLogout}>
                {isLoading && (
                  <Spinner animation="grow" size="sm" role="status">
                    <span className="visually-hidden"></span>
                  </Spinner>
                )}
                Logout
              </NavDropdown.Item>
              <Link
                to="/changepassword"
                style={{
                  color: "black",
                  marginLeft: 20,
                  textDecoration: "none",
                }}
              >
                Change Password
              </Link>
            </NavDropdown>
          </div>
        </div>
      </div>
    </div>
  );
};
